const isAvailableGlobalInstance = () => {
  if (typeof window.fbq === 'undefined' || window.fbq == null) {
    console.warn('Facebook SDK is not loaded');
    return false;
  }

  return true;
};

export function logEvent(eventName: string, params?: object): void {
  const sendingParams = { ...params, client_ip_address: 'AUTO' };

  if (!isAvailableGlobalInstance()) {
    return;
  }

  try {
    window.fbq?.('track', eventName, sendingParams);
  } catch (error) {
    console.error('Error logging Facebook event:', error);
  }
}

export function logCustomEvent(eventName: string, params?: object): void {
  const sendingParams = { ...params, client_ip_address: 'AUTO' };

  if (!isAvailableGlobalInstance()) {
    return;
  }

  try {
    window.fbq?.('trackCustom', eventName, sendingParams);
  } catch (error) {
    console.error('Error logging Facebook custom event:', error);
  }
}
